import React, { useEffect } from "react";
import { Modal, Descriptions, Divider, Button, Spin } from "antd";
import { BuildOutlined, LoadingOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { ViewFeaturedBusinessProperty } from "../../Redux/Actions/featuredBusinessPropertyAction";
import "./viewFeaturedBusniessProperty.css";

const ViewFeaturedBusinessPropertyModal = ({ visible, propertyData, onClose }) => {
    const dispatch = useDispatch();

    const { featuredBusinessProperty: item, loading, error } = useSelector(
        (s) => s.featuredBusinessProperty || {}
    );

    useEffect(() => {
        if (visible && propertyData?._id) {
            dispatch(ViewFeaturedBusinessProperty(propertyData._id));
        }
    }, [visible, propertyData?._id, dispatch]);

    const formatDate = (dateString) => {
        if (!dateString) return "Not specified";
        return new Date(dateString).toLocaleDateString("en-IN", {
            year: "numeric",
            month: "long",
            day: "numeric",
        });
    };

    const data = item || propertyData;

    const renderBody = () => {
        if (loading) {
            return (
                <div className="view-hb-loader">
                    <Spin indicator={<LoadingOutlined style={{ fontSize: 36, color: "#070C18" }} spin />} />
                    <p className="view-hb-loader-text">Loading property details…</p>
                </div>
            );
        }

        if (error) {
            return (
                <div className="view-hb-error">
                    <p>Failed to load property details. Please try again.</p>
                </div>
            );
        }

        return (
            <>
                {/* Property Information */}
                <div className="view-hb-card">
                    <h3 className="view-hb-card-header">Property Information</h3>
                    <div className="view-hb-grid">
                        <Descriptions column={2} bordered size="small">
                            <Descriptions.Item label="Property ID">
                                <span style={{ fontSize: "12px", fontFamily: "monospace", color: "#6b7280" }}>
                                    {data?.property?.property_id || "—"}
                                </span>
                            </Descriptions.Item>
                            <Descriptions.Item label="Type">
                                <span className="view-hb-type-badge">
                                    {data?.property?.type || "N/A"}
                                </span>
                            </Descriptions.Item>
                            <Descriptions.Item label="Ranking">
                                <span className="view-hb-value">{data?.ranking ?? 0}</span>
                            </Descriptions.Item>
                            <Descriptions.Item label="Property Status">
                                <span
                                    style={{
                                        background: data?.property?.status === "published" ? "#e6f9f0"
                                            : data?.property?.status === "unpublished" ? "#fff7e6" : "#f5f5f5",
                                        color: data?.property?.status === "published" ? "#0a7c42"
                                            : data?.property?.status === "unpublished" ? "#b45309" : "#333",
                                        padding: "2px 10px", borderRadius: "12px",
                                        fontSize: "12px", fontWeight: 600, textTransform: "capitalize",
                                    }}
                                >
                                    {data?.property?.status || "—"}
                                </span>
                            </Descriptions.Item>
                            <Descriptions.Item label="Created">
                                {formatDate(data?.created_at)}
                            </Descriptions.Item>
                            <Descriptions.Item label="Updated">
                                {formatDate(data?.updated_at)}
                            </Descriptions.Item>
                        </Descriptions>
                    </div>
                </div>

                <Divider className="view-hb-divider" />

                {/* About Property */}
                {data?.property?.about_property && (
                    <>
                        <div className="view-hb-card">
                            <h3 className="view-hb-card-header">About Property</h3>
                            <p style={{ color: "#374151", fontSize: 14, lineHeight: 1.6, margin: 0 }}>
                                {data.property.about_property}
                            </p>
                        </div>
                        <Divider className="view-hb-divider" />
                    </>
                )}

                {/* Location Details */}
                <div className="view-hb-card">
                    <h3 className="view-hb-card-header">Location Details</h3>
                    <div className="view-hb-grid">
                        <Descriptions column={2} bordered size="small">
                            <Descriptions.Item label="Country">
                                {data?.country?.country_name || "—"}
                            </Descriptions.Item>
                            <Descriptions.Item label="State">
                                {data?.state?.state_name || "—"}
                            </Descriptions.Item>
                            <Descriptions.Item label="City">
                                {data?.city?.city_name || "—"}
                            </Descriptions.Item>
                        </Descriptions>
                    </div>
                </div>
            </>
        );
    };

    return (
        <Modal
            title={
                <div className="view-hb-modal-header-content">
                    <BuildOutlined className="view-hb-modal-header-icon" style={{ color: "white" }} />
                    <span style={{ color: "white" }}>FEATURED BUSINESS PROPERTY DETAILS</span>
                </div>
            }
            open={visible}
            onCancel={onClose}
            footer={null}
            destroyOnClose
            width={800}
            className="view-hb-modal-override"
            styles={{
                header: {
                    background: "#070C18",
                    borderRadius: "12px 12px 0 0",
                    padding: "20px 24px",
                    borderBottom: "none",
                },
                body: {
                    padding: "24px",
                    background: "#fafafa",
                },
            }}
        >
            <div className="view-hb-modal-content">

                {renderBody()}

                <Divider className="view-hb-divider" />

                <div className="view-hb-actions">
                    <Button
                        size="large"
                        onClick={onClose}
                        style={{ background: "#070C18" }}
                        className="view-hb-btn view-hb-btn-primary"
                    >
                        Close
                    </Button>
                </div>

            </div>
        </Modal>
    );
};

export default ViewFeaturedBusinessPropertyModal;